import { Injectable } from '@angular/core';
import {
  AbstractControl,
  AsyncValidator,
  ValidationErrors,
} from '@angular/forms';
import { ZipCodeStatus, ZipCodeVerificationQueryService } from 'graphql-client';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ResidenceZipCodeAsyncValidator implements AsyncValidator {
  constructor(
    private readonly zipCodeVerificationQueryService: ZipCodeVerificationQueryService
  ) {}

  validate({
    value: zipCode,
  }: AbstractControl): Observable<ValidationErrors | null> {
    return this.zipCodeVerificationQueryService.fetch({ zipCode }).pipe(
      map((response) => {
        const { zipCodeIsValid, zipCodeStatus } =
          response.data.zipCodeVerification;
        switch (true) {
          case zipCodeIsValid:
            return null;
          case zipCodeStatus === ZipCodeStatus.InvalidTerritoryError:
            return { territoryError: true };
          default:
            return { zipCodeError: true };
        }
      }),
      catchError(() => of(null))
    );
  }
}
